/* BIO · Animaciones de página (CULT + Academia + FAQ) — progressive enhancement.
   Sin este script la página se ve normal; con él: decoraciones + scroll reveal. */
(function () {
  'use strict';
  if (window.__bioAnimInit) return;
  window.__bioAnimInit = true;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (REDUCED) return;

  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function localIndex(el, cls) {
    var i = 0, p = el.previousElementSibling;
    while (p) { if (p.classList && p.classList.contains(cls)) i++; p = p.previousElementSibling; }
    return i;
  }

  /* Decoraciones de fondo inyectadas (no viven en el liquid de las secciones) */
  function decorate() {
    $all('.bio-cult-hero').forEach(function (hero) {
      if (hero.querySelector('.bio-anim-cult-bg')) return;
      var bg = document.createElement('div');
      bg.className = 'bio-anim-cult-bg';
      bg.setAttribute('aria-hidden', 'true');
      bg.innerHTML = '<i class="bio-anim-cult-bg__pulse"></i><i class="bio-anim-cult-bg__embers"></i><i class="bio-anim-cult-bg__embers e2"></i>';
      hero.style.position = 'relative';
      hero.style.overflow = 'hidden';
      hero.insertBefore(bg, hero.firstChild);
      var inner = hero.querySelector('.bio-cult-hero__inner');
      if (inner) inner.style.position = 'relative';
    });
    $all('.bio-academia-hero').forEach(function (hero) {
      if (hero.querySelector('.bio-anim-acad-bg')) return;
      var bg = document.createElement('div');
      bg.className = 'bio-anim-acad-bg';
      bg.setAttribute('aria-hidden', 'true');
      bg.innerHTML = '<i class="bio-anim-acad-bg__grid"></i><i class="bio-anim-acad-bg__glow g1"></i><i class="bio-anim-acad-bg__glow g2"></i>';
      hero.style.position = 'relative';
      hero.style.overflow = 'hidden';
      hero.insertBefore(bg, hero.firstChild);
      var inner = hero.querySelector('.bio-academia-hero__inner');
      if (inner) inner.style.position = 'relative';
    });
    $all('.bio-faq__inner').forEach(function (inner) {
      if (inner.querySelector('.bio-anim-faq-rail')) return;
      var rail = document.createElement('i');
      rail.className = 'bio-anim-faq-rail';
      rail.setAttribute('aria-hidden', 'true');
      inner.style.position = 'relative';
      inner.appendChild(rail);
    });
  }

  /* Scroll reveal */
  var REVEAL = [
    { sel: '.bio-cult-eligibles__chip', cls: 'bio-cult-eligibles__chip', stagger: 0.06, base: 0 },
    { sel: '.bio-cult-rank',            cls: 'bio-cult-rank',            stagger: 0.13, base: 0 },
    { sel: '.bio-cult-mision__card',    cls: 'bio-cult-mision__card',    stagger: 0,    base: 0 },
    { sel: '.bio-cult-mision__teaser',  cls: 'bio-cult-mision__teaser',  stagger: 0,    base: 0.18 },
    { sel: '.bio-cult-apply',           cls: 'bio-cult-apply',           stagger: 0,    base: 0 },
    { sel: '.bio-academia__grupo-titulo', cls: 'bio-academia__grupo-titulo', stagger: 0, base: 0 },
    { sel: '.bio-academia__card',       cls: 'bio-academia__card',       stagger: 0.055, base: 0.05 },
    { sel: '.bio-faq__group-title',     cls: 'bio-faq__group-title',     stagger: 0,    base: 0 },
    { sel: '.bio-faq__item',            cls: 'bio-faq__item',            stagger: 0.05, base: 0.04 }
  ];

  var io = null;

  function arm() {
    if (!('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('bio-anim-on');
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('bio-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -7% 0px', threshold: 0.06 });
    }
    REVEAL.forEach(function (cfg) {
      $all(cfg.sel).forEach(function (el) {
        if (el.classList.contains('bio-rv')) return;
        el.classList.add('bio-rv');
        var d = cfg.base + localIndex(el, cfg.cls) * cfg.stagger;
        el.style.setProperty('--bio-d', d.toFixed(2) + 's');
        io.observe(el);
      });
    });
  }

  function init() { decorate(); arm(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
